import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useController, useFormContext, } from 'react-hook-form';
import clsx from 'clsx';
import FormLabel from '@enquiryForm/components/FormLabel';
import FormGroup from '@enquiryForm/components/FormGroup';
import { useCallback } from 'react';
function ToggleInput(props) {
    const { inputAttrs, labelAttrs } = props;
    const { name, className: forwardedInputClasses } = inputAttrs;
    const { control, setValue } = useFormContext();
    const { field: { value }, fieldState: { invalid, isTouched, error }, } = useController({ name, control });
    const className = clsx('form__control checkbox__input', forwardedInputClasses, { invalid: invalid && isTouched });
    const handleInputChange = useCallback((ev) => {
        setValue(name, ev.currentTarget.checked, { shouldTouch: true, shouldValidate: true });
    }, [name, setValue]);
    return (_jsx(FormGroup, { className: error ? 'form__group--error' : '', children: _jsxs("div", { className: "checkbox", children: [_jsx("input", { ...inputAttrs, type: "checkbox", checked: value, onChange: handleInputChange, value: value, className: className }), _jsx(FormLabel, { className: "checkbox__label", ...labelAttrs })] }) }));
}
export default ToggleInput;
